import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "progress", "progressBar", "progressText"]
  static values = {
    url: String,
    completed: Boolean
  }

  connect() {
    if (!this.completedValue) {
      this.startPolling()
    }
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.poll()
    this.interval = setInterval(() => this.poll(), 2000)
  }

  stopPolling() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          "Accept": "application/json"
        }
      })

      if (!response.ok) return

      const data = await response.json()

      if (this.hasProgressBarTarget) {
        this.progressBarTarget.querySelector(".bg-blue-600").style.width = `${data.progress}%`
      }

      if (this.hasProgressTextTarget) {
        this.progressTextTarget.textContent = `${data.processed_rows} di ${data.total_rows} righe elaborate (${data.progress}%)`
      }

      if (data.status === "completed" || data.status === "failed") {
        this.stopPolling()
        // Reload page to show final state
        window.location.reload()
      }
    } catch (error) {
      console.error("Error polling import status:", error)
    }
  }
}
